import { ErrorHandler } from '@angular/core';

// This is needed so the typescript transpiler will not return an error on the global atatus property
// simply checking 'if (atatus) {' did not work it causes an exception.
declare global {
  interface Window {
    atatus: any;
  }
}

export class AtatusErrorHandler implements ErrorHandler {
  constructor(private accountKey: string, private environmentName: string) {}

  handleError(error: any): void {
    // checking the atatus property on the window directly causes an error if we dont load atatus.
    if (window.atatus) {
      console.log('here');

      const atatus: any = window.atatus;

      if (!this.accountKey) {
        console.log('there');
        this.accountKey = 'NoAccountKeySupplied';
      }

      // Send the error to Atatus, adding custom data (not searchable but still could help when looking at a specific error)
      atatus.notify(
        error.originalError || error,
        {
          environmentName: this.environmentName,
          accountKey: this.accountKey,
        },
        this.environmentName
      );
    }

    // in any case show it also on the console (do not remove this otherwise it will swallow errors)
    console.error(error);
  }
}

export default AtatusErrorHandler;
